import { render, staticRenderFns } from "./AdManagerFormats.vue?vue&type=template&id=35d4ddfc"
import script from "./AdManagerFormats.js?vue&type=script&lang=js&external"
export * from "./AdManagerFormats.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports